<section id="section01">

  <div class="container-fluid" id="section01row01">  
    
    <div class="container">

      <div class="row d-flex justify-content-center align-items-center">
        <div class="col-lg-8">
          <h2>{{ data.TITULO }}</h2>
          <h4 class="mb-0">{{ data.DESCRICAO }}</h4>
          <div class="row mt-3 mb-3 justify-content-center align-items-center">
            <img class="img-fluid" src="{{ data.IMAGEM.URL }}">
          </div>
        </div>
      </div>
    
    </div>

  </div>  

  <div class="container-fluid" id="section01row02">  
    
      <div class="container">
      
          <div class="row d-flex justify-content-center align-items-center" id="section01row02">
            <div class="col-lg-12">
              <h4 class="mb-0 mt-0">{{ data.DESCRICAO2 }} <br class="d-none d-md-inline"> {{ data.DESCRICAO3 }}</h4>
            </div>
          </div>
          
      </div>
    
  </div>
  
</section>